# Used in Onboarding, Credit and other product types that requires a messaging system
# Allows to upload files into the chat

MAX_FILES_UPLOAD = 12 # max files to upload, per message

setupFileUpload = ->
  if ($fileUploaders = $ '[data-behaviour="message-file-uploader"]').length
    $fileUploaders.each ->
      $el = $ @
      processFiles = (ev) ->
        fileList = ev.target.files || ev.originalEvent.dataTransfer.files
        if fileList.length
          $el.addClass 'chat-input--with-files'
          $ul = $el.find '.chat-input__files'
          $ul = $('<ul class="chat-input__files"/>').appendTo($el) unless $ul.length
          $ul.empty()
          for f, index in fileList
            break if index >= MAX_FILES_UPLOAD
            $li = $ '<li class="chat-input__file"></li>'
            $li.append f.name
            $li.append ' <span class="filesize">(' + $CAM.formatFileSize(f.size) + ')</span>'
            $ul.append $li
          $($el.data('view')).trigger 'update'
      $el.find('[type="file"]').on 'change', processFiles

$(document).ready(setupFileUpload)